// This lists options that apply to packages. The option names/keys are used to get translations from .properties files.
// Example: "skipass" in this config takes "planningSummary_options_skipass" content from translation

export default {
    HS: [],
    PF: ["skipass"],
    PFF: ["skipass", "flight","transport"],
    PFCS: ["skipass"],
    PFP: ["skipass", "materiel"],
    PFPF: ["skipass", "materiel", "flight", "transport"],
    HF: ["flight", "transport"],
    PFPCS: ["skipass", "materiel"],
    PFTT: ["transport", "skipass"],
    PFTTNL: ["transport", "skipass"],
    PFTTUK: ["transport", "skipass"],
    PFPTTNL: ["transport", "skipass", "materiel"],
    PFPTTUK: ["transport", "skipass", "materiel"],
    PFTT_7: ["home", "transport", "skipass"],
    PFTT_8: ["home", "night", "transport", "skipass"],
    PFTTF: ["transport", "skipass"],
    PFPTT: ["transport", "skipass", "materiel"],
    PFPTT_7: ["home", "transport", "skipass", "materiel"],
    PFPTT_8: ["home", "night", "transport", "skipass", "materiel"],
    HTT: ["home","transport"],
    HTT_PLUS1: ["home","night","transport"],
    HTTF: ["transport"],
    PFPTTF: ["transport", "skipass", "materiel"],
    PMA: ["passMultiActivities"],
};
